const theme = {
  text: "#666370",
  body: "#FFFFFF",
  primary: "#e7859c",
  primaryLight: "#eb9daf",
  secondary: "#79CAC2",
  secondaryLight: "#93d4ce",
  shadow: "#CCCCCC",
  lightGrey: "#d0d0d0",
  midGrey: "#a0a0a0",
  darkGrey: "#525252",
  black: "#333333",
  red: "#ee2f53",
  fontLobster: "'Lobster', cursive",
  fontBody: "'Poppins', sans-serif;",
  fontHeading: "'Poppins', sans-serif;",
  fontButton: "'Poppins', sans-serif;",
  fontNav: "'Poppins', sans-serif;",
  border: "5px solid",
  borderRadius: "8px",
  fatBorder: "10px solid",
  drawerWidth: "400px",
  drawerMaxWidth: "100vw",
  transitionTime: "0.3s",
  opacity: "0.6",
  textMaxWidth: "500px",
  breakpoints: {
    xs: 375,
    sm: 480,
    md: 768,
    lg: 1120,
    xl: 1440
  },
  devices: {
    xs: 'min-width: 375px',
    sm: 'min-width: 480px',
    md: 'min-width: 768px',
    lg: 'min-width: 1120px',
    xl: 'min-width: 1440px'
  }
};
export default theme;